import { createFileRoute } from "@tanstack/react-router";
import { AdminsPage } from "../features/admins/admins-page";

export const Route = createFileRoute("/admins")({ component: AdminsPage });
